(function() {
  'use strict';

  var GLOBAL_KEY = '__g3DesktopMegaMenu';
  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].initialize(document);
    return;
  }

  var ROOT_SELECTOR = '[data-desktop-mega-root]';
  var TRIGGER_SELECTOR = '[data-desktop-mega-trigger]';
  var PANEL_SELECTOR = '[data-desktop-mega-panel]';
  var VEIL_SELECTOR = '[data-desktop-mega-veil]';
  var BREAKPOINT = '(min-width: 769px)';
  var OPEN_DELAY = 140;
  var CLOSE_DELAY = 180;
  var ROOT_OPEN_CLASS = 'is-desktop-mega-open';
  var BODY_OPEN_CLASS = 'desktop-mega-menu-open';
  var READY_CLASS = 'is-desktop-mega-ready';
  var NAV_LAYOUT_ATTRIBUTE = 'data-desktop-nav-layout';
  var INLINE_EXIT_TOLERANCE = 4;
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var instances = new Map();
  var mediaQuery = window.matchMedia(BREAKPOINT);
  var hoverMediaQuery = window.matchMedia('(any-hover: hover) and (any-pointer: fine)');

  function cleanLabel(element) {
    if (!element) {
      return '';
    }

    var label = element.dataset.menuLabel || element.textContent || '';
    return label.replace(/\s+/g, ' ').trim();
  }

  function analyticsValue(element, key, fallback) {
    if (!element) {
      return fallback;
    }

    return element.dataset[key] || fallback;
  }

  function pushInteraction(details) {
    try {
      if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
        return;
      }

      window.dataLayer.push({
        event: 'g3_desktop_menu_interaction',
        action: details.action,
        section: details.section,
        element: details.element,
        label: details.label
      });
    } catch (error) {
    }
  }

  function pushQuizClick() {
    try {
      if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
        return;
      }

      window.dataLayer.push({
        event: 'g3_quiz_menu_click',
        placement: 'desktop_menu'
      });
    } catch (error) {
    }
  }

  function isPrimaryUnmodifiedClick(event) {
    return event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return value.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }

  function panelForTrigger(root, trigger) {
    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;

    if (panel && root.contains(panel) && panel.matches(PANEL_SELECTOR)) {
      return panel;
    }

    var key = trigger.getAttribute('data-desktop-mega-trigger');
    if (!key) {
      return null;
    }

    return root.querySelector(PANEL_SELECTOR + '[data-desktop-mega-panel="' + cssEscape(key) + '"]');
  }

  function runViewTransition(update) {
    update();
  }

  function DesktopMegaMenu(root) {
    this.root = root;
    this.owner = root.closest('.site-header') || root.closest('[data-section-type="header-section"]') || root.parentElement || root;
    this.triggers = Array.prototype.slice.call(this.owner.querySelectorAll(TRIGGER_SELECTOR));
    this.panels = Array.prototype.slice.call(root.querySelectorAll(PANEL_SELECTOR));
    this.veil = root.querySelector(VEIL_SELECTOR) || document.querySelector(VEIL_SELECTOR);
    this.section = this.owner.closest('[data-section-type="header-section"]') || document;
    this.headerWrapper = this.section.querySelector('[data-header-style]');
    this.thumbMenu = this.section.querySelector('.site-nav__thumb-menu');
    this.mobileDrawer = this.section.querySelector('.slide-nav__overflow--thumb') || document.querySelector('.slide-nav__overflow--thumb');
    this.headerLayout = this.owner.querySelector('.header-layout--right');
    this.navigation = this.headerLayout && this.headerLayout.querySelector('.header-item--navigation .site-navigation');
    this.thumbMenuObserver = null;
    this.navMutationObserver = null;
    this.legacyDropdownObserver = null;
    this.resizeObserver = null;
    this.navLayoutFrame = null;
    this.items = [];
    this.activeItem = null;
    this.activeSource = null;
    this.openTimer = null;
    this.closeTimer = null;
    this.scrollFocusPending = false;
    this.scrollFocusElement = null;
    this.desktopMatches = mediaQuery.matches;
    this.destroyed = false;
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;

    this.buildItems();
    this.prepareLegacyDropdowns();
    if (this.items.length) {
      this.owner.classList.add(READY_CLASS);
    }
    this.scheduleNavLayout();
    this.bindEvents();
    this.observeGeometry();
    this.resetState();
  }

  DesktopMegaMenu.prototype.observeGeometry = function() {
    var self = this;
    if (typeof window.ResizeObserver === 'function') {
      this.resizeObserver = new ResizeObserver(function() {
        self.scheduleNavLayout();
        if (mediaQuery.matches && self.activeItem) {
          self.updateHoverBridge();
        }
      });
      this.resizeObserver.observe(this.owner);
      this.resizeObserver.observe(this.root);
      if (this.headerLayout) {
        this.resizeObserver.observe(this.headerLayout);
      }
      if (this.navigation) {
        this.resizeObserver.observe(this.navigation);
      }
    }

    if (this.navigation && typeof window.MutationObserver === 'function') {
      this.navMutationObserver = new MutationObserver(function() {
        self.scheduleNavLayout();
      });
      this.navMutationObserver.observe(this.navigation, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        self.scheduleNavLayout();
      }).catch(function() {
      });
    }
  };

  DesktopMegaMenu.prototype.prepareLegacyDropdowns = function() {
    var self = this;
    var dropdownItems = this.owner.querySelectorAll(
      '.site-nav--has-dropdown, .site-nav__deep-dropdown-trigger'
    );

    dropdownItems.forEach(function(item) {
      var control = item.querySelector(':scope > a[aria-controls]');
      if (control) {
        control.setAttribute('aria-expanded', String(item.classList.contains('is-focused')));
      }
    });

    if (dropdownItems.length && typeof window.MutationObserver === 'function') {
      this.legacyDropdownObserver = new MutationObserver(function() {
        self.syncLegacyDropdownStates();
      });
      dropdownItems.forEach(function(item) {
        self.legacyDropdownObserver.observe(item, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }
  };

  DesktopMegaMenu.prototype.syncLegacyDropdownStates = function() {
    this.owner.querySelectorAll('.site-nav--has-dropdown, .site-nav__deep-dropdown-trigger').forEach(function(item) {
      var control = item.querySelector(':scope > a[aria-controls]');
      if (control) {
        control.setAttribute('aria-expanded', String(item.classList.contains('is-focused')));
      }
    });
  };

  DesktopMegaMenu.prototype.closeLegacyDropdown = function(event) {
    var item = event.target.closest && event.target.closest(
      '.site-nav--has-dropdown, .site-nav__deep-dropdown-trigger'
    );
    if (!item || !this.owner.contains(item)) {
      return;
    }

    var control = item.querySelector(':scope > a[aria-controls]');
    var topLevelItem = item.closest('.site-nav--has-dropdown') || item;
    topLevelItem.querySelectorAll('.is-focused').forEach(function(openItem) {
      openItem.classList.remove('is-focused');
    });
    topLevelItem.classList.remove('is-focused');
    this.syncLegacyDropdownStates();
    event.preventDefault();
    event.stopPropagation();
    if (control) {
      this.focusWithoutScrolling(control);
    }
  };

  DesktopMegaMenu.prototype.scheduleNavLayout = function() {
    if (this.destroyed || this.navLayoutFrame !== null) {
      return;
    }

    var self = this;
    this.navLayoutFrame = window.requestAnimationFrame(function() {
      self.navLayoutFrame = null;
      self.syncNavLayout();
    });
  };

  DesktopMegaMenu.prototype.syncNavLayout = function() {
    if (!this.headerLayout || !this.navigation) {
      return;
    }

    var navItems = Array.prototype.slice.call(this.navigation.children).filter(function(child) {
      return child.classList.contains('site-nav__item');
    });

    if (!mediaQuery.matches || !navItems.length) {
      this.headerLayout.removeAttribute(NAV_LAYOUT_ATTRIBUTE);
      this.navigation.classList.remove('desktop-nav--single-row', 'desktop-nav--multirow', 'desktop-nav--single-item');
      return;
    }

    var logoItem = this.headerLayout.querySelector(':scope > .header-item--logo');
    var logo = logoItem && (logoItem.querySelector('.site-header__logo-link') || logoItem);
    var icons = this.headerLayout.querySelector(':scope > .header-item--icons');
    var navigationItem = this.navigation.closest('.header-item--navigation');
    var layoutWidth = this.headerLayout.getBoundingClientRect().width;
    var logoWidth = logo ? logo.getBoundingClientRect().width : 0;
    var iconsWidth = icons ? icons.getBoundingClientRect().width : 0;
    var navigationStyles = navigationItem ? window.getComputedStyle(navigationItem) : null;
    var navigationMargins = navigationStyles ?
      (parseFloat(navigationStyles.marginLeft) || 0) + (parseFloat(navigationStyles.marginRight) || 0) : 0;
    var headerGap = parseFloat(window.getComputedStyle(this.headerLayout).columnGap) || 0;
    var itemGap = parseFloat(window.getComputedStyle(this.navigation).columnGap) || 0;
    var availableWidth = Math.max(
      0,
      layoutWidth - logoWidth - iconsWidth - navigationMargins - (headerGap * 2)
    );
    var itemWidth = 0;

    navItems.forEach(function(item) {
      itemWidth += item.getBoundingClientRect().width;
    });

    var requiredInlineWidth = itemWidth + (itemGap * Math.max(0, navItems.length - 1));
    var currentLayout = this.headerLayout.getAttribute(NAV_LAYOUT_ATTRIBUTE);
    var inlineThreshold = requiredInlineWidth;
    if (currentLayout === 'inline') {
      inlineThreshold -= INLINE_EXIT_TOLERANCE;
    }

    var layout = availableWidth >= inlineThreshold ? 'inline' : 'multirow';

    if (currentLayout !== layout) {
      if (this.activeItem) {
        this.close('layout-change');
      }
      this.headerLayout.setAttribute(NAV_LAYOUT_ATTRIBUTE, layout);
    }

    var isInline = layout === 'inline';
    this.navigation.classList.toggle('desktop-nav--single-row', isInline);
    this.navigation.classList.toggle('desktop-nav--multirow', !isInline);
    this.navigation.classList.toggle('desktop-nav--single-item', navItems.length === 1);
  };

  DesktopMegaMenu.prototype.buildItems = function() {
    var self = this;

    this.triggers.forEach(function(trigger) {
      var panel = panelForTrigger(self.root, trigger);

      if (!panel) {
        trigger.setAttribute('aria-expanded', 'false');
        return;
      }

      if (!panel.id) {
        panel.id = 'DesktopMegaPanel-' + Math.random().toString(36).slice(2, 10);
      }

      trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', 'false');
      self.items.push({
        trigger: trigger,
        panel: panel,
        navItem: trigger.closest('.desktop-mega-nav__item') || trigger,
        suppressKeyboardClick: false
      });
    });
  };

  DesktopMegaMenu.prototype.bindEvents = function() {
    var self = this;
    var listenerOptions = { signal: this.signal };

    this.items.forEach(function(item) {
      item.navItem.addEventListener('pointerenter', function(event) {
        self.handlePointerEnter(item, event);
      }, listenerOptions);
      item.navItem.addEventListener('pointerleave', function(event) {
        self.handlePointerLeave(item, event);
      }, listenerOptions);
      item.trigger.addEventListener('keydown', function(event) {
        self.handleTriggerKeydown(item, event);
      }, listenerOptions);
      item.trigger.addEventListener('click', function(event) {
        self.handleTriggerClick(item, event);
      }, listenerOptions);
      item.panel.addEventListener('pointerenter', function() {
        self.clearTimers();
      }, listenerOptions);
      item.panel.addEventListener('pointerleave', function(event) {
        self.handlePointerLeave(item, event);
      }, listenerOptions);
      item.panel.addEventListener('keydown', function(event) {
        self.handlePanelKeydown(item, event);
      }, listenerOptions);
    });

    this.owner.addEventListener('focusout', function(event) {
      if (self.activeItem && !self.owner.contains(event.relatedTarget)) {
        self.close('focusout');
      }
    }, listenerOptions);

    this.owner.addEventListener('click', function(event) {
      self.handleNavigationClick(event);
    }, listenerOptions);

    this.owner.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        self.closeLegacyDropdown(event);
      }
    }, listenerOptions);

    this.root.addEventListener('click', function(event) {
      self.handleRootClick(event);
    }, listenerOptions);

    if (this.veil) {
      this.veil.addEventListener('click', function() {
        self.close('veil', { returnFocus: true });
      }, listenerOptions);
    }

    if (this.thumbMenu && typeof window.MutationObserver === 'function') {
      this.thumbMenuObserver = new MutationObserver(function() {
        self.reconcileThumbMenuFocus();
      });
      this.thumbMenuObserver.observe(this.thumbMenu, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    window.addEventListener('scroll', function() {
      if (mediaQuery.matches && self.activeItem) {
        self.close('scroll');
      }
      self.reconcileScrollFocus();
    }, { passive: true, signal: this.signal });

    window.addEventListener('resize', function() {
      self.syncBreakpoint(mediaQuery.matches);
      self.scheduleNavLayout();
      if (mediaQuery.matches && self.activeItem) {
        self.updateHoverBridge();
      }
    }, { passive: true, signal: this.signal });
  };

  DesktopMegaMenu.prototype.handlePointerEnter = function(item, event) {
    if (!this.canHoverItem(item, event)) {
      return;
    }

    this.clearTimers();

    if (this.activeItem === item) {
      return;
    }

    var self = this;
    this.openTimer = window.setTimeout(function() {
      self.openTimer = null;
      self.open(item, 'hover');
    }, OPEN_DELAY);
  };

  DesktopMegaMenu.prototype.updateHoverBridge = function() {
    if (!this.activeItem || !this.activeItem.navItem) {
      return;
    }

    var triggerRect = this.activeItem.trigger.getBoundingClientRect();
    var navigation = this.activeItem.trigger.closest('.site-navigation');
    var navigationRect = navigation ? navigation.getBoundingClientRect() : triggerRect;
    var rootRect = this.root.getBoundingClientRect();
    var bridgeOffset = Math.max(0, navigationRect.bottom - triggerRect.bottom);
    var bridgeHeight = Math.max(0, rootRect.top - navigationRect.bottom);
    var availableHeight = Math.max(0, window.innerHeight - rootRect.top);
    this.activeItem.navItem.style.setProperty('--desktop-mega-trigger-bridge-offset', bridgeOffset + 'px');
    this.activeItem.navItem.style.setProperty('--desktop-mega-trigger-bridge-height', bridgeHeight + 'px');
    this.activeItem.navItem.classList.add('is-desktop-mega-nav-active');
    this.root.style.setProperty('--desktop-mega-available-height', availableHeight + 'px');
  };

  DesktopMegaMenu.prototype.handlePointerLeave = function(item, event) {
    if (!this.canHoverItem(item, event)) {
      return;
    }

    this.clearOpenTimer();

    if (item.navItem.contains(document.activeElement) || item.panel.contains(document.activeElement)) {
      return;
    }

    var destination = event.relatedTarget;
    if (destination && (item.navItem.contains(destination) || item.panel.contains(destination))) {
      return;
    }

    if (destination && this.activeItem && (
      this.activeItem.navItem.contains(destination) ||
      this.activeItem.panel.contains(destination)
    )) {
      return;
    }

    var self = this;
    this.clearCloseTimer();
    this.closeTimer = window.setTimeout(function() {
      self.closeTimer = null;
      self.close('pointerleave');
    }, CLOSE_DELAY);
  };

  DesktopMegaMenu.prototype.canHoverItem = function(item, event) {
    return mediaQuery.matches &&
      event.pointerType !== 'touch' &&
      (event.pointerType === 'mouse' || hoverMediaQuery.matches);
  };

  DesktopMegaMenu.prototype.handleTriggerKeydown = function(item, event) {
    if (mediaQuery.matches && event.key === 'Tab' && !event.shiftKey && this.activeItem === item) {
      var firstFocusable = this.firstFocusable(item.panel);

      if (firstFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
      return;
    }

    if (!mediaQuery.matches || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    event.preventDefault();
    item.suppressKeyboardClick = true;
    window.setTimeout(function() {
      item.suppressKeyboardClick = false;
    }, 100);
    this.toggle(item, 'keyboard');
  };

  DesktopMegaMenu.prototype.handleTriggerClick = function(item, event) {
    if (!mediaQuery.matches || event.defaultPrevented) {
      return;
    }

    if (event.detail === 0 && item.suppressKeyboardClick) {
      item.suppressKeyboardClick = false;
      event.preventDefault();
      return;
    }

    event.preventDefault();
    this.toggle(item, event.detail === 0 ? 'keyboard' : 'click');
  };

  DesktopMegaMenu.prototype.handlePanelKeydown = function(item, event) {
    if (!mediaQuery.matches || event.key !== 'Tab') {
      return;
    }

    var firstFocusable = this.firstFocusable(item.panel);
    if (event.shiftKey && firstFocusable && event.target === firstFocusable) {
      event.preventDefault();
      item.trigger.focus();
      return;
    }

    var lastFocusable = this.lastFocusable(item.panel);
    var nextControl = !event.shiftKey && event.target === lastFocusable ? this.nextNavigationControl(item) : null;
    if (nextControl) {
      event.preventDefault();
      this.focusWithoutScrolling(nextControl);
      this.close('tab-exit');
    }
  };

  DesktopMegaMenu.prototype.firstFocusable = function(panel) {
    var candidates = panel.querySelectorAll(FOCUSABLE_SELECTOR);

    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      if (
        !candidate.hidden &&
        !candidate.closest('[inert]') &&
        candidate.getClientRects().length > 0 &&
        window.getComputedStyle(candidate).visibility !== 'hidden'
      ) {
        return candidate;
      }
    }

    return null;
  };

  DesktopMegaMenu.prototype.lastFocusable = function(panel) {
    var candidates = panel.querySelectorAll(FOCUSABLE_SELECTOR);

    for (var index = candidates.length - 1; index >= 0; index -= 1) {
      var candidate = candidates[index];
      if (
        !candidate.hidden &&
        !candidate.closest('[inert]') &&
        candidate.getClientRects().length > 0 &&
        window.getComputedStyle(candidate).visibility !== 'hidden'
      ) {
        return candidate;
      }
    }

    return null;
  };

  DesktopMegaMenu.prototype.nextNavigationControl = function(item) {
    var sibling = item.navItem && item.navItem.nextElementSibling;

    while (sibling) {
      var controls = sibling.querySelectorAll(FOCUSABLE_SELECTOR);
      for (var index = 0; index < controls.length; index += 1) {
        if (this.isVisible(controls[index])) {
          return controls[index];
        }
      }
      sibling = sibling.nextElementSibling;
    }

    return null;
  };

  DesktopMegaMenu.prototype.isVisible = function(element) {
    if (!element || !document.documentElement.contains(element)) {
      return false;
    }

    if (element.hidden || element.closest('[hidden], [inert]')) {
      return false;
    }

    var styles = window.getComputedStyle(element);
    if (styles.display === 'none' || styles.visibility === 'hidden') {
      return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth;
  };

  DesktopMegaMenu.prototype.focusWithoutScrolling = function(element) {
    if (!element || typeof element.focus !== 'function') {
      return false;
    }

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }

    return document.activeElement === element;
  };

  DesktopMegaMenu.prototype.thumbMenuButton = function() {
    var stickyCartButton = document.querySelector(
      '#StickyCart.sticky-cart--open .js-toggle-slide-nav, .body--sticky-cart-open #StickyCart .js-toggle-slide-nav'
    );

    if (this.isVisible(stickyCartButton)) {
      return stickyCartButton;
    }

    if (!this.thumbMenu) {
      return null;
    }

    return this.thumbMenu.querySelector('.js-toggle-slide-nav, button:not([disabled])');
  };

  DesktopMegaMenu.prototype.setThumbMenuActive = function(active) {
    if (
      window.theme &&
      window.theme.headerNav &&
      typeof window.theme.headerNav.toggleThumbMenu === 'function'
    ) {
      window.theme.headerNav.toggleThumbMenu(active);
      return;
    }

    if (this.thumbMenu) {
      this.thumbMenu.classList.toggle('site-nav__thumb-menu--inactive', !active);
    }
    document.body.classList.toggle('sticky-nav--is-open', active);
  };

  DesktopMegaMenu.prototype.firstVisibleHeaderControl = function(preferred) {
    if (this.isVisible(preferred)) {
      return preferred;
    }

    var controls = this.owner.querySelectorAll(
      '.site-navigation button:not([disabled]), .site-navigation a[href], .site-header__logo a[href], a[href], button:not([disabled])'
    );

    for (var index = 0; index < controls.length; index += 1) {
      if (this.isVisible(controls[index])) {
        return controls[index];
      }
    }

    return null;
  };

  DesktopMegaMenu.prototype.focusAfterPanelClose = function(item, source) {
    var thumbButton = this.thumbMenuButton();
    var usesFloatingButton = this.headerWrapper && this.headerWrapper.dataset.headerStyle === 'button';
    var shouldUseFloatingButton = usesFloatingButton && thumbButton && (
      !mediaQuery.matches ||
      (source === 'scroll' && window.scrollY > 100)
    );

    if (source === 'scroll') {
      this.scrollFocusPending = true;
      this.scrollFocusElement = null;
    }

    if (shouldUseFloatingButton) {
      this.setThumbMenuActive(true);
      if (this.isVisible(thumbButton) && this.focusWithoutScrolling(thumbButton)) {
        this.clearScrollFocusPending();
        return;
      }
    }

    var headerControl = this.firstVisibleHeaderControl(item && item.trigger);
    if (headerControl && this.focusWithoutScrolling(headerControl)) {
      if (source === 'scroll') {
        this.scrollFocusElement = headerControl;
      }
      return;
    }

    if (this.isVisible(thumbButton)) {
      this.focusWithoutScrolling(thumbButton);
    }
  };

  DesktopMegaMenu.prototype.clearScrollFocusPending = function() {
    this.scrollFocusPending = false;
    this.scrollFocusElement = null;
  };

  DesktopMegaMenu.prototype.reconcileScrollFocus = function() {
    if (!this.scrollFocusPending) {
      return;
    }

    if (this.scrollFocusElement && document.activeElement !== this.scrollFocusElement) {
      this.clearScrollFocusPending();
      return;
    }

    if (window.scrollY <= 100) {
      return;
    }

    var thumbButton = this.thumbMenuButton();
    var usesFloatingButton = this.headerWrapper && this.headerWrapper.dataset.headerStyle === 'button';
    if (!usesFloatingButton || !thumbButton) {
      this.clearScrollFocusPending();
      return;
    }

    this.setThumbMenuActive(true);
    if (this.isVisible(thumbButton) && this.focusWithoutScrolling(thumbButton)) {
      this.clearScrollFocusPending();
    }
  };

  DesktopMegaMenu.prototype.handleBreakpointChange = function(matchesDesktop) {
    this.clearScrollFocusPending();

    var activeElement = document.activeElement;
    var thumbButton = this.thumbMenuButton();

    if (matchesDesktop) {
      var focusWasInMobileMenu = !!(
        (this.thumbMenu && this.thumbMenu.contains(activeElement)) ||
        (this.mobileDrawer && this.mobileDrawer.contains(activeElement))
      );
      var drawerWasOpen = !!(
        this.mobileDrawer &&
        this.mobileDrawer.classList.contains('js-menu--is-open')
      );

      if (drawerWasOpen && thumbButton) {
        thumbButton.click();
      }

      if (focusWasInMobileMenu || drawerWasOpen) {
        var desktopControl = this.firstVisibleHeaderControl(this.triggers[0]);
        if (desktopControl) {
          this.focusWithoutScrolling(desktopControl);
        }
      }
      return;
    }

    var focusWasInDesktopMenu = !!(
      this.owner.contains(activeElement) ||
      this.root.contains(activeElement)
    );

    this.close('breakpoint');

    if (focusWasInDesktopMenu && !this.isVisible(document.activeElement)) {
      var mobileHeaderControl = this.firstVisibleHeaderControl(
        this.owner.querySelector('.site-header__logo-link')
      );

      if (mobileHeaderControl) {
        this.focusWithoutScrolling(mobileHeaderControl);
      }
    }
  };

  DesktopMegaMenu.prototype.syncBreakpoint = function(matchesDesktop) {
    if (this.desktopMatches === matchesDesktop) {
      return;
    }

    this.desktopMatches = matchesDesktop;
    this.handleBreakpointChange(matchesDesktop);
    this.scheduleNavLayout();
  };

  DesktopMegaMenu.prototype.reconcileThumbMenuFocus = function() {
    if (
      this.scrollFocusPending &&
      this.thumbMenu &&
      !this.thumbMenu.classList.contains('site-nav__thumb-menu--inactive')
    ) {
      this.reconcileScrollFocus();
      return;
    }

    if (
      !this.thumbMenu ||
      !this.thumbMenu.classList.contains('site-nav__thumb-menu--inactive') ||
      !this.thumbMenu.contains(document.activeElement) ||
      this.isVisible(document.activeElement)
    ) {
      return;
    }

    var headerControl = this.firstVisibleHeaderControl(this.triggers[0]);
    if (headerControl) {
      this.focusWithoutScrolling(headerControl);
    }
  };

  DesktopMegaMenu.prototype.handleRootClick = function(event) {
    if (!mediaQuery.matches || !this.activeItem) {
      return;
    }

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || !this.activeItem.panel.contains(link)) {
      return;
    }

    var section = analyticsValue(link, 'menuSection', this.sectionFor(this.activeItem));
    var element = analyticsValue(link, 'menuElement', 'link');

    pushInteraction({
      action: 'navigate',
      section: section,
      element: element,
      label: cleanLabel(link)
    });

    var href = link.getAttribute('href') || '';
    if (link.dataset.menuType === 'quiz' || /(?:^|[/?#])gear-finder(?:$|[/?#])/.test(href) || href.indexOf('#gear-finder') !== -1) {
      pushQuizClick();
    }

    if (isPrimaryUnmodifiedClick(event)) {
      this.close('link');
    }
  };

  DesktopMegaMenu.prototype.handleNavigationClick = function(event) {
    if (!mediaQuery.matches) {
      return;
    }

    var link = event.target.closest && event.target.closest('.site-navigation a[href]');
    if (!link || !this.owner.contains(link)) {
      return;
    }

    pushInteraction({
      action: 'navigate',
      section: analyticsValue(link, 'menuSection', 'top-level'),
      element: analyticsValue(link, 'menuElement', 'destination'),
      label: cleanLabel(link)
    });
  };

  DesktopMegaMenu.prototype.toggle = function(item, source) {
    this.clearTimers();

    if (this.activeItem === item) {
      this.close(source);
      return;
    }

    this.open(item, source);
  };

  DesktopMegaMenu.prototype.open = function(item, source) {
    if (this.destroyed || !mediaQuery.matches || !item || this.activeItem === item) {
      return;
    }

    this.clearTimers();
    this.clearScrollFocusPending();

    var previousItem = this.activeItem;
    if (previousItem) {
      if (previousItem.panel.contains(document.activeElement)) {
        this.focusWithoutScrolling(item.trigger);
      }

      pushInteraction({
        action: 'close',
        section: this.sectionFor(previousItem),
        element: analyticsValue(previousItem.trigger, 'menuElement', 'trigger'),
        label: cleanLabel(previousItem.trigger)
      });
    }

    this.activeItem = item;
    this.activeSource = source;
    this.updateHoverBridge();
    var self = this;
    runViewTransition(function() {
      if (previousItem) {
        self.setItemState(previousItem, false);
      }
      self.setItemState(item, true);
      self.root.classList.add(ROOT_OPEN_CLASS);
      document.body.classList.add(BODY_OPEN_CLASS);
      document.documentElement.classList.add(BODY_OPEN_CLASS);

      if (self.veil) {
        self.veil.hidden = false;
        self.veil.removeAttribute('inert');
      }
    });

    pushInteraction({
      action: 'open',
      section: this.sectionFor(item),
      element: analyticsValue(item.trigger, 'menuElement', 'trigger'),
      label: cleanLabel(item.trigger)
    });
  };

  DesktopMegaMenu.prototype.close = function(source, options) {
    this.clearTimers();

    if (!this.activeItem) {
      this.syncBodyClass();
      return false;
    }

    options = options || {};
    var item = this.activeItem;
    var panelHadFocus = item.panel.contains(document.activeElement);
    this.activeItem = null;
    this.activeSource = null;
    var self = this;
    runViewTransition(function() {
      self.setItemState(item, false);
      self.root.classList.remove(ROOT_OPEN_CLASS);

      if (self.veil) {
        self.veil.hidden = true;
        self.veil.setAttribute('inert', '');
      }

      self.syncBodyClass();
    });

    pushInteraction({
      action: 'close',
      section: this.sectionFor(item),
      element: analyticsValue(item.trigger, 'menuElement', 'trigger'),
      label: cleanLabel(item.trigger)
    });

    if (options.returnFocus && document.documentElement.contains(item.trigger)) {
      this.focusWithoutScrolling(item.trigger);
    } else if (panelHadFocus) {
      this.focusAfterPanelClose(item, source);
    }

    return true;
  };

  DesktopMegaMenu.prototype.sectionFor = function(item) {
    return analyticsValue(
      item.trigger,
      'menuSection',
      analyticsValue(item.panel, 'menuSection', analyticsValue(this.root, 'menuSection', 'root'))
    );
  };

  DesktopMegaMenu.prototype.setItemState = function(item, open) {
    item.trigger.setAttribute('aria-expanded', String(open));
    item.panel.hidden = !open;
    item.navItem.classList.toggle('is-desktop-mega-nav-active', open);

    if (!open) {
      item.navItem.style.removeProperty('--desktop-mega-trigger-bridge-offset');
      item.navItem.style.removeProperty('--desktop-mega-trigger-bridge-height');
    }

    if (open) {
      item.panel.removeAttribute('inert');
    } else {
      item.panel.setAttribute('inert', '');
    }
  };

  DesktopMegaMenu.prototype.resetState = function() {
    var self = this;
    this.activeItem = null;
    this.activeSource = null;
    this.root.classList.remove(ROOT_OPEN_CLASS);
    this.items.forEach(function(item) {
      self.setItemState(item, false);
    });

    if (this.veil) {
      this.veil.hidden = true;
      this.veil.setAttribute('inert', '');
    }

    this.syncBodyClass();
  };

  DesktopMegaMenu.prototype.syncBodyClass = function() {
    var anyOpen = false;
    instances.forEach(function(instance) {
      if (!instance.destroyed && instance.activeItem) {
        anyOpen = true;
      }
    });

    document.body.classList.toggle(BODY_OPEN_CLASS, anyOpen);
    document.documentElement.classList.toggle(BODY_OPEN_CLASS, anyOpen);
  };

  DesktopMegaMenu.prototype.clearOpenTimer = function() {
    if (this.openTimer !== null) {
      window.clearTimeout(this.openTimer);
      this.openTimer = null;
    }
  };

  DesktopMegaMenu.prototype.clearCloseTimer = function() {
    if (this.closeTimer !== null) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  };

  DesktopMegaMenu.prototype.clearTimers = function() {
    this.clearOpenTimer();
    this.clearCloseTimer();
  };

  DesktopMegaMenu.prototype.destroy = function() {
    if (this.destroyed) {
      return;
    }

    this.close('section-unload');
    this.destroyed = true;
    this.abortController.abort();
    this.clearScrollFocusPending();
    if (this.thumbMenuObserver) {
      this.thumbMenuObserver.disconnect();
    }
    if (this.navMutationObserver) {
      this.navMutationObserver.disconnect();
    }
    if (this.legacyDropdownObserver) {
      this.legacyDropdownObserver.disconnect();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.navLayoutFrame !== null) {
      window.cancelAnimationFrame(this.navLayoutFrame);
      this.navLayoutFrame = null;
    }
    if (this.headerLayout) {
      this.headerLayout.removeAttribute(NAV_LAYOUT_ATTRIBUTE);
    }
    if (this.navigation) {
      this.navigation.classList.remove('desktop-nav--single-row', 'desktop-nav--multirow', 'desktop-nav--single-item');
    }
    this.owner.classList.remove(READY_CLASS);
    instances.delete(this.root);
    this.syncBodyClass();
  };

  function closeAll(source, options) {
    instances.forEach(function(instance) {
      instance.close(source, options);
    });
  }

  function initialize(scope) {
    var searchScope = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (searchScope.matches && searchScope.matches(ROOT_SELECTOR)) {
      roots.push(searchScope);
    }

    roots = roots.concat(Array.prototype.slice.call(searchScope.querySelectorAll(ROOT_SELECTOR)));
    roots.forEach(function(root) {
      if (!instances.has(root)) {
        instances.set(root, new DesktopMegaMenu(root));
      }
    });
  }

  function handleDocumentPointerDown(event) {
    if (!mediaQuery.matches) {
      return;
    }

    instances.forEach(function(instance) {
      var insideTrigger = instance.triggers.some(function(trigger) {
        return trigger.contains(event.target);
      });

      if (!instance.activeItem || instance.root.contains(event.target) || insideTrigger) {
        return;
      }

      if (instance.veil && instance.veil.contains(event.target)) {
        return;
      }

      instance.close('outside-pointer');
    });
  }

  function handleDocumentClick(event) {
    if (!mediaQuery.matches) {
      return;
    }

    instances.forEach(function(instance) {
      var insideTrigger = instance.triggers.some(function(trigger) {
        return trigger.contains(event.target);
      });

      if (!instance.activeItem || instance.root.contains(event.target) || insideTrigger) {
        return;
      }

      if (instance.veil && instance.veil.contains(event.target)) {
        return;
      }

      instance.close('outside-click');
    });
  }

  function handleDocumentKeydown(event) {
    if (event.key === 'Escape') {
      closeAll('escape', { returnFocus: true });
    }
  }

  function handleBreakpointChange(event) {
    instances.forEach(function(instance) {
      instance.syncBreakpoint(event.matches);
    });
  }

  function handleSectionLoad(event) {
    initialize(event.target);
  }

  function handleSectionUnload(event) {
    instances.forEach(function(instance) {
      if (event.target === instance.root || event.target.contains(instance.root)) {
        instance.destroy();
      }
    });
  }

  function start() {
    initialize(document);
    document.addEventListener('pointerdown', handleDocumentPointerDown, true);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleDocumentKeydown);
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleBreakpointChange);
    } else {
      mediaQuery.addListener(handleBreakpointChange);
    }
  }

  window[GLOBAL_KEY] = {
    initialize: initialize,
    closeAll: closeAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
